import SiteLayout from "@/components/site/SiteLayout";
import PageBanner from "@/components/site/PageBanner";
import Services from "@/components/site/Services";
import VideoShowcase from "@/components/site/VideoShowcase";
import FinalCta from "@/components/site/FinalCta";
import usePageMeta from "@/hooks/usePageMeta";

export default function ServicesPage() {
  usePageMeta(
    "Our Services — Gold Mind Business | Performance Marketing, Funnels & AI Automation",
    "Explore Gold Mind Business services: performance marketing (Meta & Google Ads), creative & branding, funnels & landing pages, social media growth, local SEO and AI automation for businesses in Delhi and across India."
  );
  return (
    <SiteLayout testId="services-page">
      <PageBanner
        title="Our Services"
        subtitle="End-to-end growth systems — from first click to closed deal — engineered around your business goals."
      />
      <Services />
      <VideoShowcase />
      <FinalCta />
    </SiteLayout>
  );
}
